t = require('views/internal/teacup-with-helpers')('member')

avatarDomain = window.avatarDomain

module.exports = t.renderable ({ id, avatarHash, fullName, username, initials, isDeactivated, isBoardAdmin, isOrganizationAdmin, hideBadges }) ->
  if avatarHash
    t.img '.member-avatar', {
      height: '30'
      width: '30'
      src: [avatarDomain, avatarHash, '30.png'].join('/')
      srcset:
        [
          [avatarDomain, avatarHash, '30.png 1x'].join('/')
          [avatarDomain, avatarHash, '50.png 2x'].join('/')
        ].join(', ')
      alt: "#{ fullName } (#{ username })",
      title: "#{ fullName } (#{ username })",
    }
  else
    t.span '.member-initials',
      title: "#{ fullName } (#{ username })"
    , ->
      t.text initials

  t.span "##{id}-avatar"

  if !isDeactivated && !hideBadges
    if isBoardAdmin
      t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-board') }
    if isOrganizationAdmin
      t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-organization') }

  if !hideBadges
    t.span '.member-gold-badge', { title: t.l('this-member-has-trello-gold') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member.coffee